import React from 'react';
import UserImage from "./UserImage";

class ImageCropper extends React.Component {

    constructor(props) {
        super(props);

        this.cropper = null;

        this.state = {
            processingImage: false
        }

        this.handleCropperClose = this.handleCropperClose.bind(this);
        this.handleSelectCrop = this.handleSelectCrop.bind(this);

    }

    componentDidMount() {


    }

    componentDidUpdate(prevProps, prevState, snapshot) {


        if (!this.props.image || !this.imageCropperImage || this.cropper !== null)
            return null;


        var aspectRatio = this.props.activePerspective.imageDimensions.width / this.props.activePerspective.imageDimensions.height;

        const activeBackground = this.props.activeBackground;

        this.cropper = new window.Cropper(this.imageCropperImage, {

            aspectRatio: aspectRatio,
            checkCrossOrigin: false,
            viewMode: 2,

            ready: function () {


                if (activeBackground.has_cropperoverlay)
                {
                    this.cropper.face.style.backgroundImage = 'url("'+activeBackground.cropperoverlay+'")';
                    this.cropper.face.style.backgroundSize = 'cover';
                    this.cropper.face.style.opacity = '0.8';
                    this.cropper.face.style.backgroundColor = 'rgb(255 255 255 / 0%)';
                }

                /*


    background-image: url(https://dev1.hunde-shop.de/out/pictures/productdesigner/backgrounds/keksdose54bc9-front-herz-herz-cropperoverlay.png);
    background-size: cover;
    opacity: 0.8;
    background-color: rgb(255 255 255 / 0%);
                 */
                // var cropper = this.cropper;
                // var containerData = cropper.getContainerData();
                // var cropBoxData = cropper.getCropBoxData();
                // var aspectRatio = cropBoxData.width / cropBoxData.height;
                // var newCropBoxWidth;
                //
                // if (aspectRatio < minAspectRatio || aspectRatio > maxAspectRatio) {
                //     newCropBoxWidth = cropBoxData.height * ((minAspectRatio + maxAspectRatio) / 2);
                //
                //     cropper.setCropBoxData({
                //         left: (containerData.width - newCropBoxWidth) / 2,
                //         width: newCropBoxWidth
                //     });
                // }
            },

            cropmove: function () {
                // var cropper = this.cropper;
                // var cropBoxData = cropper.getCropBoxData();
                // var aspectRatio = cropBoxData.width / cropBoxData.height;
                //
                // if (aspectRatio < minAspectRatio) {
                //     cropper.setCropBoxData({
                //         width: cropBoxData.height * minAspectRatio
                //     });
                // } else if (aspectRatio > maxAspectRatio) {
                //     cropper.setCropBoxData({
                //         width: cropBoxData.height * maxAspectRatio
                //     });
                // }
            },
        });

    }

    handleSelectCrop(e) {
        e.preventDefault();

        var cropBoxData = this.cropper.getData(true);

        var formData = new FormData();
        this.client = new XMLHttpRequest();

        formData.append("imageData", JSON.stringify(cropBoxData));
        formData.append("imageName", this.props.imageName);

        this.client.onerror = function(e) {
            this.setState({
                errorText: 'Fehler beim hochladen!',
                processingImage: false
            });
        };
        this.client.onerror = this.client.onerror.bind(this);


        this.client.onload = function(e) {

            this.setState({
                processingImage: false
            });

            this.props.onCropperDone(new UserImage(this.client.responseText, this.props.imageName));
            this.cropper.destroy();
            this.cropper = null;
            this.props.onCropperClose();


        };
        this.client.onload = this.client.onload.bind(this);


        this.setState({
            processingImage: true,
        });

        this.client.open("POST", this.props.userUploadInterface + "&fnc=cropUserImage");
        this.client.send(formData);

    }

    handleCropperClose(e) {
        e.preventDefault();

        this.setState({
            processingImage: false
        });

        if (this.client !== null && this.client !== undefined)
            this.client.abort();

        this.cropper.destroy();
        this.cropper = null;
        this.props.onCropperClose();
    }

    render() {

        if (!this.props.image)
            return null;

        return (
            <div className="modal fade in" id="cropper_modal" tabIndex="-1" role="dialog" aria-labelledby="modalLabel"
                    aria-hidden="true" ref={ (imageCropperModal) => this.imageCropperModal = imageCropperModal}
                    style={ {display: 'block'} }>
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="modalLabel">Bild zuschneiden</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.handleCropperClose}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="img-container">
                                <img id="designer-cropper-image" src={this.props.image} ref={ (imageCropperImage) => this.imageCropperImage = imageCropperImage}/>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={this.handleCropperClose}>Abbrechen</button>
                            <button type="button" className="btn btn-primary" disabled={ this.state.processingImage } onClick={ this.handleSelectCrop } >{ this.state.processingImage ? 'Wird verarbeitet' : 'Auswählen' }</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default ImageCropper;



// WEBPACK FOOTER //
// ./src/ImageCropper.js